import { useState } from 'react';
import { useSettings } from '../settings/SettingsContext.js';
import { PALETTES, PALETTE_ORDER, type PaletteId } from '../lib/palettes.js';
import { LOGO_ORDER, LOGO_VARIANTS, type LogoVariant } from '../lib/logos.js';

// One-time popup (shown after the light/dark chooser) letting the user pick their ROLODEX logo colour
// AND a colour theme. Both preview live; Continue records the choice. Changeable any time in Settings.
export function FirstRunPaletteModal() {
  const { needsPaletteChoice, chooseBrand, setLogo, setPalette, prefs } = useSettings();
  const [logo, setLogoSel] = useState<LogoVariant>((prefs.logo as LogoVariant) ?? 'silver');
  const [pal, setPal] = useState<PaletteId>(prefs.palette ?? 'indigo');
  if (!needsPaletteChoice) return null;

  const pickLogo = (v: LogoVariant) => { setLogoSel(v); setLogo(v); }; // preview live
  const pickPal = (v: PaletteId) => { setPal(v); setPalette(v, false); };

  return (
    <div className="modal-bg" style={{ zIndex: 300 }}>
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="first-run-palette-title" style={{ width: 620, maxWidth: '95vw' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-hd"><h3 id="first-run-palette-title">Make it yours</h3></div>
        <div className="modal-bd">
          <p className="muted" style={{ marginTop: 0 }}>
            Pick your ROLODEX logo and a colour theme. Both work with light or dark mode and can be changed
            any time in Settings.
          </p>

          <div className="settings-label" style={{ marginBottom: 8 }}>Logo</div>
          <div className="logo-choices" style={{ marginBottom: 18 }}>
            {LOGO_ORDER.map((id) => (
              <button key={id} type="button" className={`logo-choice ${logo === id ? 'sel' : ''}`}
                aria-pressed={logo === id} onClick={() => pickLogo(id)} title={LOGO_VARIANTS[id].label}>
                <img src={LOGO_VARIANTS[id].src} alt="" width={44} height={31} style={{ objectFit: 'contain' }} />
                <span>{LOGO_VARIANTS[id].label}</span>
              </button>
            ))}
          </div>

          <div className="settings-label" style={{ marginBottom: 8 }}>Colour theme</div>
          {/* grouped as on the Settings page: the colours that pair with a logo, then the rest */}
          {([['brand', 'ROLODEX colours'], ['more', 'More colours']] as const).map(([group, label]) => (
            <div key={group} className="pal-group" role="group" aria-label={label}>
              <p className="pal-group-hd">{label}</p>
              <div className="pal-choices">
                {PALETTE_ORDER.filter((id) => PALETTES[id].group === group).map((id) => (
                  <button key={id} type="button" className={`pal-choice ${pal === id ? 'sel' : ''}`}
                    aria-pressed={pal === id} onClick={() => pickPal(id)} title={PALETTES[id].blurb}>
                    <span className="pal-sw" style={{ background: PALETTES[id].swatch }}>
                      <span className="pal-dot" style={{ background: PALETTES[id].accent }} />
                    </span>
                    <span>{PALETTES[id].label}</span>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="modal-ft">
          <button className="btn btn-primary" autoFocus onClick={() => chooseBrand(logo, pal)}>Continue</button>
        </div>
      </div>
    </div>
  );
}
